import { useMemo } from 'react'; 
import { useMutation } from '@apollo/client';
import COMPONENT_LIST_SET_CREATE from '../mutations/COMPONENT_LIST_SET_CREATE';

const useComponentListSetCreate = () => {
    const [ createComponentList ] = useMutation( COMPONENT_LIST_SET_CREATE );

    const createCLS = async ( saveData ) => {
        try {
            const response = await createComponentList( { variables: { input: saveData } } );
            const success = response?.data?.createComponentListSet;

            if ( success ) {
                return {
                    success: true,
                    response: response.data.createComponentListSet
                };
            } else {
                return {
                    success: false,
                    response
                };
            }
        } catch ( error ) { 
            console.error( 'Error creating component list set', error );  
            return {
                success: false,
                response: false
            };
        } 
    };

    return useMemo( () => {
        return {
            createCLS         
        };
    }, [] );
};

export default useComponentListSetCreate;
